var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pageNotFound"}},[_c('div',{staticClass:"Box"},[_c('h1',[_vm._v("404 PageNotFound")])])])}]

export { render, staticRenderFns }